import React from 'react'
import CommonBanner from '../component/Common/CommonBanner'
import FlightBookingArea from 'component/FlightBooking'
import { useTranslation } from 'react-i18next';
const FlightBooking = () => {
  const { t } = useTranslation();
  return (
    <>
    <CommonBanner heading={t("bookingSubmission")} pagination="Booking submission"/>
    <FlightBookingArea/>
    </>
  )
}

export default FlightBooking